import { render, staticRenderFns } from "./criterion_form.vue?vue&type=template&id=df2c5b18&scoped=true&"
import script from "./criterion_form.vue?vue&type=script&lang=ts&"
export * from "./criterion_form.vue?vue&type=script&lang=ts&"
import style0 from "./criterion_form.vue?vue&type=style&index=0&id=df2c5b18&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2c5b18",
  null
  
)

export default component.exports